import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateChangeApplicationStatusList = {
  changeApplicationStatusList: { data: null, loading: false, error: null },
};

export const changeApplicationStatusList = createAsyncThunk('user/changeApplicationStatusList', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/vacancies/applications/status`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerChangeApplicationStatusList = {
  [changeApplicationStatusList.pending]: (state) => {
    // state.changeApplicationStatusList.data = null;
    state.changeApplicationStatusList.loading = true;
    state.changeApplicationStatusList.error = null;
  },
  [changeApplicationStatusList.fulfilled]: (state, action) => {
    state.changeApplicationStatusList.loading = false;
    state.changeApplicationStatusList.data = true;
    state.changeApplicationStatusList.error = null;
  },
  [changeApplicationStatusList.rejected]: (state, action) => {
    state.changeApplicationStatusList.loading = false;
    state.changeApplicationStatusList.error = action.payload;
  },
};
